import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserManagement, UserInviteResponse, UserManagementInviteData } from '../../types/user';

interface UsersState {
  users: UserManagement[];
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  users: [],
  loading: false,
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    // Fetch users
    fetchUsersRequest: state => {
      state.loading = true;
      state.error = null;
    },
    fetchUsersSuccess: (state, action: PayloadAction<UserManagement[]>) => {
      state.loading = false;
      state.users = action.payload;
      state.error = null;
    },
    fetchUsersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Invite user
    inviteUserRequest: (state, action: PayloadAction<UserManagementInviteData>) => {
      state.loading = true;
      state.error = null;
    },
    inviteUserSuccess: (state, action: PayloadAction<UserInviteResponse>) => {
      state.loading = false;
      // Add new users to the list
      state.users.push(...action.payload.invited_users);
      state.error = null;
    },
    inviteUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete user
    deleteUserRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    deleteUserSuccess: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.users = state.users.filter(user => user.id !== action.payload);
      state.error = null;
    },
    deleteUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear error
    clearUsersError: state => {
      state.error = null;
    },
  },
});

export const {
  fetchUsersRequest,
  fetchUsersSuccess,
  fetchUsersFailure,
  inviteUserRequest,
  inviteUserSuccess,
  inviteUserFailure,
  deleteUserRequest,
  deleteUserSuccess,
  deleteUserFailure,
  clearUsersError,
} = usersSlice.actions;

export default usersSlice.reducer;
